/**
 * Generic API response wrapper that matches the backend response structure
 */
export interface ApiResponse<T = any> {
  data: T;
  isSuccess: boolean;
  message: string | null;
}

/**
 * Error response structure
 */
export interface ApiErrorResponse {
  isSuccess: false;
  message: string;
  data: any;
}

/**
 * Success response structure
 */
export interface ApiSuccessResponse<T> {
  isSuccess: true;
  data: T;
  message: string | null;
}

/**
 * Type guard to check if response is successful
 */
export function isSuccessResponse<T>(response: ApiResponse<T>): response is ApiSuccessResponse<T> {
  return response.isSuccess === true;
}

/**
 * Type guard to check if response is an error
 */
export function isErrorResponse(response: ApiResponse<any>): response is ApiErrorResponse {
  return response.isSuccess === false;
}
